import namespace from "@rdfjs/namespace";
export const vs = namespace("http://www.w3.org/2003/06/sw-vocab-status/ns#");
